/**
 * Purchase order document classes (po_type).
 * Spot/Market Purchase is orthogonal via procurement_method — not a po_type value.
 */

export const PO_TYPE_STANDARD = 'Standard';
export const PO_TYPE_BLANKET = 'Blanket';
export const PO_TYPE_PLANNED = 'Planned';
export const PO_TYPE_CONTRACT = 'Contract';

export const PO_TYPES_PRIMARY = [
  PO_TYPE_STANDARD,
  PO_TYPE_BLANKET,
  PO_TYPE_PLANNED,
  PO_TYPE_CONTRACT,
] as const;

export type PrimaryPoType = (typeof PO_TYPES_PRIMARY)[number];

export const ENVELOPE_PO_TYPES = [
  PO_TYPE_BLANKET,
  PO_TYPE_PLANNED,
  PO_TYPE_CONTRACT,
] as const;

export type EnvelopePoType = (typeof ENVELOPE_PO_TYPES)[number];

export const PO_TYPE_OPTIONS: { value: PrimaryPoType; label: string; description: string }[] = [
  {
    value: PO_TYPE_STANDARD,
    label: 'Standard',
    description: 'Firm order with items, pricing, and delivery dates',
  },
  {
    value: PO_TYPE_BLANKET,
    label: 'Blanket',
    description: 'Standing order; create releases for recurring deliveries',
  },
  {
    value: PO_TYPE_PLANNED,
    label: 'Planned',
    description: 'Agreed items and pricing; schedule delivery via releases',
  },
  {
    value: PO_TYPE_CONTRACT,
    label: 'Contract',
    description: 'Long-term terms and rates; issue call-offs against the agreement',
  },
];

export function normalizePoType(value: string | null | undefined): string {
  const t = String(value || PO_TYPE_STANDARD).trim();
  return t || PO_TYPE_STANDARD;
}

export function isEnvelopePoType(value: string | null | undefined): boolean {
  return (ENVELOPE_PO_TYPES as readonly string[]).includes(normalizePoType(value));
}

export function isReceivablePo(po: {
  po_type?: string | null;
  parent_po_id?: string | null;
}): boolean {
  if (isEnvelopePoType(po.po_type) && !po.parent_po_id) {
    return false;
  }
  return true;
}

export function envelopeChildActionLabel(parentPoType: string | null | undefined): 'release' | 'call-off' {
  return normalizePoType(parentPoType) === PO_TYPE_CONTRACT ? 'call-off' : 'release';
}
